import React, { useEffect, useState } from 'react';
import styles from './Parameters.module.css';
import localeRu from '../../../../locales/ru/stations/stationControl.json';
import localeEn from '../../../../locales/en/stations/stationControl.json';
import phaseA from "../../../../img/phaseA.svg";
import phaseABig from "../../../../img/phaseABig.png";
import phaseB from "../../../../img/phaseB.svg";
import phaseBBig from "../../../../img/phaseВBig.png";
import phaseC from "../../../../img/phaseC.svg";
import phaseCBig from "../../../../img/phaseСBig.png";
import powerIcon from "../../../../img/powerIcon.png";
import powerIconSmall from "../../../../img/powerIconSmall.svg";
import timeIcon from "../../../../img/clockMini.svg";
import timeIconBig from "../../../../img/clockBig.png";
import consumedEnergyIcon from "../../../../img/batteryMini.svg";
import consumedEnergyIconBig from "../../../../img/batteryBig.png";

const Parameters = ({ connector }) => {
    let lang = localStorage.getItem('language') === 'ru';

    const formatTime = (seconds) => {
        if (seconds == null) {
            return "00:00";
        }
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
    };

    const formatAmperege = (amperage) => {
        // if (!amperage) {
        //     return "0.0";
        // }
        // const parseAmpere = (amperage * 1).toFixed(1);
        // return parseAmpere;
        if (!amperage) {
            return "0";
        }
        const parseAmpere = (amperage * 1).toFixed(0);
        return parseAmpere;
    };

    const formatPower = (power) => {
        if (!power) {
            return "0";
        }
        const parsePower = (power / 1000).toFixed(1);
        return parsePower;
    };

    const formatPowerCommon = (power) => {
        return (power / 1).toFixed(1);
    }

    const formatConsumedEnergy = (power) => {
        return (power / 100).toFixed(1);
    }

    return (
        <div className={styles.parameters}>
            <p className={styles.titleText}>{lang ? "Параметры" : "Parameters"}</p>
            <div className={styles.blocks}>
                {/* Column 1 */}
                <div className={styles.sectionParameters}>
                    <div className={styles.paramContainer}>
                        <div className={styles.firstSection}>
                            <div className={styles.iconContainer}>
                                <img src={phaseA} className={styles.paramImage} alt='phase A' />
                            </div>
                            <p className={styles.paramText}>{lang ? localeRu.phase_a : localeEn.phase_a}</p>
                        </div>
                        <div className={styles.secondSection}>
                            <img src={phaseABig} className={styles.paramImage1} alt='phase A' />
                            <div className={styles.textContainer}>
                                <p className={styles.paramText}>{formatPower(formatAmperege(connector?.currentA) * connector?.voltageA)} 
                                    <span className={styles.unitGray}> {lang ? "кBт" : "kW"}</span></p>
                                <p className={styles.paramText}>{formatAmperege(connector?.currentA)} 
                                    <span className={styles.unitGray}> A</span></p>
                                <p className={styles.paramText}>{Math.round(connector?.voltageA)} 
                                    <span className={styles.unitGray}> {lang ? "B" : "V"}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.paramContainer}>
                        <div className={styles.firstSection}>
                            <div className={styles.iconContainer}>
                                <img src={powerIconSmall} className={styles.paramImage} alt='Power' />
                            </div>
                            <p className={styles.paramText}>{lang ? localeRu.power : localeEn.power}</p>
                        </div>
                        <div className={styles.secondSection}>
                            <img src={powerIcon} className={styles.paramImage1} alt='Power' />
                            <div className={styles.textContainerOne}>
                                <p className={styles.paramText}>{formatPowerCommon(connector?.powerCommon)}
                                    <span className={styles.unitGray}> {lang ? "кBт" : "kW"}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Column 2 */}
                <div className={styles.sectionParameters}>
                    <div className={styles.paramContainer}>
                        <div className={styles.firstSection}>
                            <div className={styles.iconContainer}>
                                <img src={phaseB} className={styles.paramImage} alt='phase B' />
                            </div>
                            <p className={styles.paramText}>{lang ? localeRu.phase_b : localeEn.phase_b}</p>
                        </div>
                        <div className={styles.secondSection}>
                            <img src={phaseBBig} className={styles.paramImage1} alt='phase B' />
                            <div className={styles.textContainer}>
                                <p className={styles.paramText}>{formatPower(formatAmperege(connector?.currentB) * connector?.voltageB)} 
                                    <span className={styles.unitGray}> {lang ? "кBт" : "kW"}</span></p>
                                <p className={styles.paramText}>{formatAmperege(connector?.currentB)} 
                                    <span className={styles.unitGray}> A</span></p>
                                <p className={styles.paramText}>{Math.round(connector?.voltageB)} 
                                    <span className={styles.unitGray}> {lang ? "B" : "V"}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.paramContainer}>
                        <div className={styles.firstSection}>
                            <div className={styles.iconContainer}>
                                <img src={timeIcon} className={styles.paramImage} alt='time' />
                            </div>
                            <p className={styles.paramText}>{lang ? localeRu.time : localeEn.time}</p>
                        </div>
                        <div className={styles.secondSection}>
                            <img src={timeIconBig} className={styles.paramImage1} alt='time' />
                            <div className={styles.textContainerOne}>
                                <p className={styles.paramText}>{formatTime(connector?.chargingTime)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Column 3 */}
                <div className={styles.sectionParameters}>
                    <div className={styles.paramContainer}>
                        <div className={styles.firstSection}>
                            <div className={styles.iconContainer}>
                                <img src={phaseC} className={styles.paramImage} alt='phase C' />
                            </div>
                            <p className={styles.paramText}>{lang ? localeRu.phase_c : localeEn.phase_c}</p>
                        </div>
                        <div className={styles.secondSection}>
                            <img src={phaseCBig} className={styles.paramImage1} alt='phase C' />
                            <div className={styles.textContainer}>
                                <p className={styles.paramText}>{formatPower(formatAmperege(connector?.currentC) * connector?.voltageC)} 
                                    <span className={styles.unitGray}> {lang ? "кBт" : "kW"}</span></p>
                                <p className={styles.paramText}>{formatAmperege(connector?.currentC)} 
                                    <span className={styles.unitGray}> A</span></p>
                                <p className={styles.paramText}>{Math.round(connector?.voltageC)} 
                                    <span className={styles.unitGray}> {lang ? "B" : "V"}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.paramContainer}>
                        <div className={styles.firstSection}>
                            <div className={styles.iconContainer}>
                                <img src={consumedEnergyIcon} className={styles.paramImage} alt='consumed' />
                            </div>
                            <p className={styles.paramText}>{lang ? localeRu.consumption : localeEn.consumption}</p>
                        </div>
                        <div className={styles.secondSection}>
                            <img src={consumedEnergyIconBig} className={styles.paramImage1} alt='consumed' />
                            <div className={styles.textContainerOne}>
                                <p className={styles.paramText}>{formatConsumedEnergy(connector?.consumedEnergy)}
                                    <span className={styles.unitGray}> {lang ? "кBтч" : "kWh"}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Parameters;